import { render, staticRenderFns } from "./RemoteBatch.vue?vue&type=template&id=38aa2c68&scoped=true&"
import script from "./RemoteBatch.vue?vue&type=script&lang=js&"
export * from "./RemoteBatch.vue?vue&type=script&lang=js&"
import style0 from "./RemoteBatch.vue?vue&type=style&index=0&id=38aa2c68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa2c68",
  null
  
)

export default component.exports